<template>
  <div class="available-products">
    <div class="header">
      <div class="flexbox flex-nowrap gap-10">
        <div class="flex input-search">
          <input v-model.trim="keyword" type="text" class="form-control input-search-keyword" placeholder="ASIN、SKU、FNSKU、商品名">
          <span class="clear-keyword-search" @click.prevent="clearKeywordSearch()"><i class="fa fa-times"></i></span>
        </div>
        <button class="btn btn-primary" @click="handleSearch()">検索</button>
      </div>
      <button class="btn btn-primary" @click="$emit('handleAddProducts')">すべて追加する</button>
    </div>
    <div class="header-mobile">
      <div class="flexbox flex-nowrap gap-10 full-width">
        <div class="flex input-search">
          <input v-model.trim="keyword" type="text" class="form-control input-search-keyword" placeholder="ASIN、SKU、FNSKU、商品名">
          <span class="clear-keyword-search" @click.prevent="clearKeywordSearch()"><i class="fa fa-times"></i></span>
        </div>
      </div>
      <div class="flexbox-between full-width">
        <button class="btn btn-primary" @click="$emit('handleAddProducts')">すべて追加する</button>
        <button class="btn btn-primary" @click="handleSearch()">検索</button>
      </div>
    </div>
    <products
      :products="products"
      :addedAsins="addedAsins"
      @handleAddProduct="handleAddProduct"
      ref="productList"
    />
  </div>
</template>

<script>
import Products from './Products'

export default {
  props: {
    products: {
      type: Array
    },
    addedAsins: {
      type: Array
    }
  },
  components: {
    Products
  },
  data () {
    return {
      keyword: ''
    }
  },
  computed: {
    saleId () {
      return this.$route.params.saleId
    }
  },
  mounted () {
  },
  methods: {
    handleSearch () {
      this.$emit('handleSearch', this.keyword)
    },
    clearKeywordSearch () {
      this.keyword = ''
    },
    handleAddProduct (asin) {
      this.$emit('handleAddProduct', asin)
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  height: 46px;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.input-search-keyword {
  min-width: 300px;
  border-radius: unset;
  border-right: unset;
  height: 35px;
}
.clear-keyword-search {
  text-align: center;
  font-size: 20px;
  color: #337ab7;
  border: 1px solid #e4e5e7;
  border-left: unset;
  padding: 0 10px;
  cursor: pointer;
  height: 35px;
}
.header-mobile {
  display: none;
}
@media (max-width: 425px) {
  .header-mobile {
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .header {
    display: none;
  }
  .input-search {
    width: 100%;
  }
  .input-search-keyword {
    min-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryAvailableProducts.vue